var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"price"},[_c('strong',{staticClass:"price__value"},[_vm._v(_vm._s(_vm.price))]),_c('span',{staticClass:"price__tax"},[_vm._v(_vm._s(_vm.secondLine))])])
}
var staticRenderFns = []

export { render, staticRenderFns }